import { useTranslation } from "react-i18next";
import {
  NavItem,
  NavList,
  NavSection,
  NavSectionHeader,
  NavSectionTitle,
  SidebarContainer,
  StyledNavLink,
} from "../../components/SidebarComponents";
import { MobileDrawerFooter, MobileDrawerHeader } from "../components/AppNavbar";
import { HelpCenterSidebarLink } from "../help/HelpCenterSidebarLink";

interface AdminSidebarProps {
  onNavigate?: () => void;
}

export const AdminSidebar = ({ onNavigate }: AdminSidebarProps) => {
  const { t } = useTranslation();
  const handleClick = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  return (
    <SidebarContainer>
      <MobileDrawerHeader onNavigate={handleClick} />
      <NavList>
        <NavSection>
          <NavSectionHeader>
            <NavSectionTitle>{t("adminSidebar.sectionTitle")}</NavSectionTitle>
          </NavSectionHeader>
          <NavItem>
            <StyledNavLink to="/admin" end onClick={handleClick}>
              {t("adminSidebar.dashboard")}
            </StyledNavLink>
          </NavItem>
          <NavItem>
            <StyledNavLink to="/admin/stores" onClick={handleClick}>
              {t("adminSidebar.stores")}
            </StyledNavLink>
          </NavItem>
          <NavItem>
            <StyledNavLink to="/admin/availableBillingItems" onClick={handleClick}>
              {t("adminSidebar.availableBillingItems")}
            </StyledNavLink>
          </NavItem>
          <NavItem>
            <StyledNavLink to="/admin/bundles" onClick={handleClick}>
              {t("adminSidebar.bundles")}
            </StyledNavLink>
          </NavItem>
          <NavItem>
            <StyledNavLink to="/admin/api-keys" onClick={handleClick}>
              {t("adminSidebar.apiKeys")}
            </StyledNavLink>
          </NavItem>
          <NavItem>
            <StyledNavLink to="/admin/chains" onClick={handleClick}>
              {t("adminSidebar.chains")}
            </StyledNavLink>
          </NavItem>
          <NavItem>
            <StyledNavLink to="/admin/resellers" onClick={handleClick}>
              {t("adminSidebar.resellers")}
            </StyledNavLink>
          </NavItem>
          <NavItem>
            <StyledNavLink to="/admin/kickback" onClick={handleClick}>
              {t("adminSidebar.kickback")}
            </StyledNavLink>
          </NavItem>
          <NavItem>
            <StyledNavLink to="/admin/reseller-invoicing" onClick={handleClick}>
              {t("adminSidebar.resellerInvoicing")}
            </StyledNavLink>
          </NavItem>
        </NavSection>
      </NavList>
      <HelpCenterSidebarLink />
      <MobileDrawerFooter />
    </SidebarContainer>
  );
};

